import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  const tagDotColors: Record<string, string> = {
    '站点更新': 'bg-primary-500',
    '功能优化': 'bg-accent-500',
    '内容发布': 'bg-secondary-500',
    '用户反馈': 'bg-accent-400',
    '合作公告': 'bg-secondary-400',
    '安全公告': 'bg-primary-400',
    '月度总结': 'bg-accent-300',
  };

  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料官网运营动态与内容更新记录</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          {updateItems.map((item) => (
            <div
              key={item.id}
              className="relative flex gap-4 pb-6 last:pb-0 group"
            >
              <div className="flex flex-col items-center">
                <span className={`flex-shrink-0 w-2.5 h-2.5 rounded-full mt-1.5 ${
                  tagDotColors[item.tag] || 'bg-foreground-400'
                }`}></span>
                <div className="w-px flex-1 bg-background-200 group-last:hidden"></div>
              </div>
              <div className="flex-1 min-w-0 pb-2">
                <div className="flex items-center flex-wrap gap-2 mb-1">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className={`px-2 py-0.5 text-[10px] font-semibold rounded ${
                    item.tag === '站点更新' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '功能优化' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '内容发布' ? 'bg-secondary-100 text-secondary-700' :
                    item.tag === '用户反馈' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '合作公告' ? 'bg-secondary-100 text-secondary-700' :
                    item.tag === '安全公告' ? 'bg-primary-100 text-primary-700' :
                    'bg-accent-100 text-accent-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm text-foreground-800 leading-relaxed font-medium">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}